import React from "react";
import { useHistory } from "react-router-dom";
import { Aside, EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../core/security/SprintAccessRight";
import { AssetCreationWarning } from "../../../../common/components/AssetCreationWarning";
import { useOnPremAssetDetails } from "../../../common/hooks/useOnPremAssetDetails";
import { resolveOnPremAssetHref } from "../../../common/resolveOnPremAssetHref";
import { isOnPremAssetDeprecated } from "../../../OnPremAssetDetails";
import { OnPremAudioAssetLanguageForm } from "./OnPremAudioAssetLanguageForm";

export interface EditOnPremAudioAssetButtonAsideProps {
    isLabeled?: boolean;
    soundtrackId: string;
}

export const EditOnPremAudioAssetButtonAside = (props: EditOnPremAudioAssetButtonAsideProps): JSX.Element => {
    const { isLabeled, soundtrackId } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    const { isLoading, data: assetDetails } = useOnPremAssetDetails();

    const areActionsDisabled = assetDetails && (isOnPremAssetDeprecated(assetDetails) || isLoading);

    const history = useHistory();

    const onSubmit = (newAssetId: string) => {
        if (!assetDetails) {
            return;
        }

        const newHref = resolveOnPremAssetHref(assetDetails.content.subtype, newAssetId);
        history.push(newHref);
        onClose();
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                disabled={areActionsDisabled}
                testId="edit-soundtrack"
            />
            <Aside type="form" headerText="Edit soundtrack" isOpen={isOpen} onDismiss={onClose} isLightDismiss={true}>
                <AssetCreationWarning />
                <OnPremAudioAssetLanguageForm onDismiss={onClose} onSubmit={onSubmit} soundtrackId={soundtrackId} />
            </Aside>
        </AuthorizationWrapper>
    );
};
